import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";

// Borderless sidebar section: an uppercase label with a divider, content below.
export function SidebarWidget(t0) {
  const $ = _c(5);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="mb-2 border-b border-divider pb-2 text-xs font-bold uppercase tracking-[0.08em] text-muted">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <section>{t1}{children}</section>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}